import { render, staticRenderFns } from "./ManagerShiftEditorContacts.vue?vue&type=template&id=25a16396&lang=pug&"
import script from "./ManagerShiftEditorContacts.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditorContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports